import UpdatePhoneNumber from '../../components/organisms/UpdatePhoneNumber'
import AccountCreationWebWrapper from '../../components/wrappers/AccountCreationWebWrapper'
const PhoneNumberUpdateScreen = (props: JSX.IntrinsicAttributes) => (
  <AccountCreationWebWrapper hasPlant={false}>
    <UpdatePhoneNumber {...props} />
  </AccountCreationWebWrapper>
)
export default PhoneNumberUpdateScreen
